module.exports = __webpack_public_path__ + "static/media/paula-greiner.aa524f4f.jpg";